<template>
  <transition name="bg-modal">
    <div
      v-if="visible"
      class="bg-modal-overlay"
      role="presentation"
      @click.self="close"
    >
      <div
        class="bg-notice-modal"
        :class="{ 'bg-notice-modal--media': isImageContent }"
        role="dialog"
        aria-modal="true"
        aria-labelledby="bg-notice-modal-title"
        @keydown.esc.prevent="close"
      >
        <header class="bg-notice-modal__header">
          <h2 id="bg-notice-modal-title" class="bg-notice-modal__title">{{ title || $t('notice.detailDefaultTitle') }}</h2>
          <button
            type="button"
            class="bg-notice-modal__close"
            :aria-label="$t('common.close')"
            @click="close"
          >
            <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true">
              <path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
            </svg>
          </button>
        </header>

        <div class="bg-notice-modal__meta">
          <span>{{ categoryLabel }}</span>
          <span>{{ formattedDate }}</span>
        </div>

        <div class="bg-notice-modal__body">
          <p v-if="loading" class="bg-notice-modal__status">{{ $t('common.loading') }}</p>
          <p v-else-if="loadError" class="bg-notice-modal__status bg-notice-modal__status--error">{{ loadError }}</p>
          <div
            v-else
            class="bg-notice-modal__content"
            :class="{ 'bg-notice-modal__content--media': isImageContent }"
            v-html="contentHtml"
          />
        </div>

        <footer class="bg-notice-modal__footer">
          <button type="button" class="bg-notice-modal__back" @click="close">{{ $t('common.backToList') }}</button>
        </footer>
      </div>
    </div>
  </transition>
</template>

<script>
import { SystemService } from '@/services'
import { formatDateTime } from '@/utils/format'
import {
  prepareNoticeContentHtml,
  isImagePopupContent
} from '@/utils/popupNotice'

export default {
  name: 'BlackGoldNoticeDetailModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    noticeIdx: {
      type: [Number, String],
      default: null
    }
  },
  data () {
    return {
      loading: false,
      loadError: '',
      title: '',
      contentHtml: '',
      regdate: '',
      noticeType: 1
    }
  },
  computed: {
    formattedDate () {
      return formatDateTime(this.regdate)
    },
    categoryLabel () {
      const value = Number(this.noticeType)
      if ((value & 4) > 0) return this.$t('notice.categoryEvent')
      if ((value & 2) > 0) return this.$t('notice.categoryPopup')
      return this.$t('notice.categoryNotice')
    },
    isImageContent () {
      return isImagePopupContent(this.contentHtml)
    }
  },
  watch: {
    visible (open) {
      if (open && this.noticeIdx != null) {
        this.loadDetail()
      }
      if (!open) {
        this.resetState()
      }
    },
    noticeIdx (idx) {
      if (this.visible && idx != null) {
        this.loadDetail()
      }
    }
  },
  methods: {
    close () {
      this.$emit('close')
    },
    resetState () {
      this.loading = false
      this.loadError = ''
      this.title = ''
      this.contentHtml = ''
      this.regdate = ''
      this.noticeType = 1
    },
    async loadDetail () {
      if (this.noticeIdx == null || this.noticeIdx === '') return
      this.loading = true
      this.loadError = ''
      this.title = ''
      this.contentHtml = ''
      this.regdate = ''
      try {
        const res = await SystemService.getNoticeDetail(this.noticeIdx)
        if (!res) {
          this.loadError = this.$t('notice.detailLoadError')
          return
        }
        if (res.data && res.data.code === 0 && res.data.data) {
          const data = res.data.data
          this.title = data.title || ''
          this.contentHtml = prepareNoticeContentHtml(data.text)
          this.regdate = data.regdate
          this.noticeType = data.type
        } else {
          this.loadError = this.$t('notice.detailLoadError')
        }
      } catch (err) {
        this.loadError = this.$t('notice.detailLoadError')
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
